/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["register{display:block}register>.auth-page .social-icons-and-register-row{display:flex}register>.auth-page .social-icons-and-register-row.social-icons-hidden .register-button{width:100%}register>.auth-page .social-icons-and-register-row>.social-buttons{flex:1 1 auto}register>.auth-page .social-icons-and-register-row>.register-button-container{flex:1 1 auto;text-align:right}register>.auth-page .info-row{margin:35px 0 5px;text-align:center}register .big-social-auth-button{margin-top:25px}register .login-link{padding-left:5px}"];
export { styles as styles };
